import { api } from '../axios/api';
import { servicios } from '../helpers/index';
import { mensaje } from '../../commons/Mensajes';
import { archivoModel } from '../models/archivo.model';
import { cajaModel } from '../models/caja.model';
import { chicaOperacionModel } from '../models/chica.operacion.model';
import { guiaModel } from '../models/guia.model';
import { ordenCompraModel } from '../models/ordencompra.model';
import { pedidoModel } from '../models/pedido.model';
import { sucursalModel } from '../models/sucursal.model';

export const ARCHIVO_PROCESS = '[Archivo] Archivo procesando';
export const ARCHIVO_SAVE_SUCCESS = '[Archivo] Archivo guardar exito';
export const ARCHIVO_LIST_SUCCESS = '[Archivo] Archivo lista exito';
export const ARCHIVO_LIST_FAIL = '[Archivo] Archivo lista error';
export const ARCHIVO_SELECTED = '[Archivo] Archivo seleccionado';
export const ARCHIVO_VIEW = '[Archivo] Archivo view';
export const ARCHIVO_CLOSE = '[Archivo] Archivo cerrar modal';
export const ARCHIVO_FILTER = '[Archivo] Archivo filtros';
export const ARCHIVO_PAGINATE = '[Archivo] Archivo paginado';
export const ARCHIVO_FAIL = '[Archivo] Archivo proceso error';

import * as fromCaja from './caja.action';
import * as fromChicaOperacion from './chica.operacion.action';
import * as fromGuia from './guia.action';
import * as fromOrden from './ordencompra.action';
import * as fromPagos from './pagos.action';
import * as fromPedido from './pedido.action';
import * as fromSucursal from './sucursal.action';

export const getArchivosAction = () => (dispatch, getState) => {
  let { su, suf, ur, ea, fi, ff, page, rows } = getState().archivo;
  let { currentUser } = getState().app;

  dispatch({
    type: ARCHIVO_PROCESS,
  });

  const params = {
    em: currentUser.ie,
    suf,
    su,
    ur: currentUser.tr === 'NOBASICO' ? ur : currentUser.us,
    ea,
    fi,
    ff,
    page,
    pageSize: rows,
  };

  api
    .get(servicios.ARCHIVO, { params })
    .then((response) => {
      dispatch({
        type: ARCHIVO_LIST_SUCCESS,
        payload: response,
      });
    })
    .catch(() => {
      dispatch({
        type: ARCHIVO_LIST_FAIL,
      });
    });
};

export const postRegistarArchivoAction =
  (item, documento) => (dispatch, getState) => {
    let { currentUser } = getState().app;

    dispatch({
      type: ARCHIVO_PROCESS,
    });

    let form_data = new FormData();
    form_data.append('file', documento);
    if (item.ar) {
      form_data.append('ar', item.ar);
    }
    form_data.append('ie', currentUser.ie);
    form_data.append('su', currentUser.is);
    form_data.append('ur', currentUser.us);
    form_data.append('ta', item.ta);

    api
      .post(`${servicios.ARCHIVO}`, form_data, {
        headers: { 'content-type': 'multipart/form-data; charset=utf-8' },
      })
      .then(() => {
        mensaje('Operación exitosa');
        dispatch(getArchivosAction());
        dispatch(paginado(0));
        dispatch({ type: ARCHIVO_SAVE_SUCCESS });
      })
      .catch((error) => {
        dispatch({
          type: ARCHIVO_FAIL,
          payload: error.data.errors ? error.data.errors : archivoModel,
        });
      });
  };

export const patchDesaprobarArchivoAction =
  (item, motivo) => (dispatch, getState) => {
    let { currentUser } = getState().app;

    dispatch({
      type: ARCHIVO_PROCESS,
    });

    let archivo = {
      ar: item.ar,
      ie: currentUser.ie,
      ua: currentUser.us,
      mt: motivo,
    };

    api
      .patch(`${servicios.ARCHIVO}/desaprobar`, archivo)
      .then(() => {
        mensaje('Operación exitosa');
        dispatch(getArchivosAction({}));
        dispatch(paginado(0));
        dispatch({ type: ARCHIVO_SAVE_SUCCESS });
      })
      .catch((error) => {
        dispatch({
          type: ARCHIVO_FAIL,
          payload: error.data.errors ? error.data.errors : archivoModel,
        });
      });
  };

export const patchRectificarArchivoAction =
  (item, motivo) => (dispatch, getState) => {
    let { currentUser } = getState().app;

    dispatch({
      type: ARCHIVO_PROCESS,
    });

    let archivo = {
      ar: item.ar,
      ie: currentUser.ie,
      ua: currentUser.us,
      mt: motivo,
    };

    api
      .patch(`${servicios.ARCHIVO}/rectificar`, archivo)
      .then(() => {
        mensaje('Operación exitosa');
        dispatch(getArchivosAction({}));
        dispatch(paginado(0));
        dispatch({ type: ARCHIVO_SAVE_SUCCESS });
      })
      .catch((error) => {
        dispatch({
          type: ARCHIVO_FAIL,
          payload: error.data.errors ? error.data.errors : archivoModel,
        });
      });
  };

export const patchAprobarArchivoAction = (item) => (dispatch, getState) => {
  let { currentUser } = getState().app;

  dispatch({
    type: ARCHIVO_PROCESS,
  });

  let archivo = {
    ar: item.ar,
    ie: currentUser.ie,
    ua: currentUser.us,
  };

  api
    .patch(`${servicios.ARCHIVO}/aprobar`, archivo)
    .then(() => {
      mensaje('Operación exitosa');
      dispatch(getArchivosAction({}));
      dispatch(paginado(0));
      dispatch({ type: ARCHIVO_SAVE_SUCCESS });
    })
    .catch((error) => {
      dispatch({
        type: ARCHIVO_FAIL,
        payload: error.data.errors ? error.data.errors : archivoModel,
      });
    });
};

export const patchEditarArchivoAction =
  (item, co, documento, call) => (dispatch, getState) => {
    let { currentUser } = getState().app;

    switch (call) {
      case 'caja':
        dispatch({
          type: fromCaja.CAJA_PROCESS,
        });
        break;
      case 'chica':
        dispatch({
          type: fromChicaOperacion.CHICAOPERACION_PROCESS,
        });
        break;
      case 'guia':
        dispatch({
          type: fromGuia.GUIA_PROCESS,
        });
        break;
      case 'orden':
        dispatch({
          type: fromOrden.ORDENCOMPRA_PROCESS,
        });
        dispatch({
          type: fromPagos.PAGOS_PROCESS,
        });
        break;
      case 'pedido':
        dispatch({
          type: fromPedido.PEDIDO_PROCESS,
        });
        break;
      case 'sucursal':
        dispatch({
          type: fromSucursal.SUCURSAL_PROCESS,
        });
        break;
      default:
        break;
    }

    dispatch({
      type: ARCHIVO_PROCESS,
    });

    let form_data = new FormData();
    form_data.append('file', documento);
    form_data.append('ar', item);
    form_data.append('ie', currentUser.ie);
    form_data.append('co', co);

    api
      .patch(`${servicios.ARCHIVO}/editar`, form_data, {
        headers: { 'content-type': 'multipart/form-data; charset=utf-8' },
      })
      .then(() => {
        mensaje('Operación exitosa');
        dispatch(getArchivosAction());
        dispatch(paginado(0));
        dispatch({ type: ARCHIVO_SAVE_SUCCESS });
        switch (call) {
          case 'caja':
            dispatch(fromCaja.getSeleccionarCajaAction());
            dispatch({ type: fromCaja.CAJA_SAVE_SUCCESS });
            break;
          case 'chica':
            dispatch(fromChicaOperacion.getOperacionesCajaChicaAction({}));
            dispatch({ type: fromChicaOperacion.CHICAOPERACION_SAVE_SUCCESS });
            break;
          case 'guia':
            dispatch(fromGuia.getGuiasAction());
            dispatch({ type: fromGuia.GUIA_SAVE_SUCCESS });
            break;
          case 'orden':
            dispatch(fromOrden.getOrdenesCompraAction({}));
            dispatch({ type: fromOrden.ORDENCOMPRA_SAVE_SUCCESS });
            dispatch(fromPagos.getPagosAction());
            dispatch({ type: fromPagos.PAGOS_SAVE_SUCCESS });
            break;
          case 'pedido':
            dispatch(fromPedido.getPedidosAction());
            dispatch({ type: fromPedido.PEDIDO_SAVE_SUCCESS });
            break;
          case 'sucursal':
            dispatch(fromSucursal.getSucursalesAction({}));
            dispatch({ type: fromSucursal.SUCURSAL_SAVE_SUCCESS });
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        dispatch({
          type: ARCHIVO_FAIL,
          payload: error.data.errors ? error.data.errors : archivoModel,
        });
        switch (call) {
          case 'caja':
            dispatch({ type: fromCaja.CAJA_FAIL, payload: cajaModel });
            break;
          case 'chica':
            dispatch({
              type: fromChicaOperacion.CHICAOPERACION_FAIL,
              payload: chicaOperacionModel,
            });
            break;
          case 'guia':
            dispatch({
              type: fromGuia.GUIA_FAIL,
              payload: guiaModel,
            });
            break;
          case 'orden':
            dispatch({
              type: fromOrden.ORDENCOMPRA_FAIL,
              payload: ordenCompraModel,
            });
            break;
          case 'pedido':
            dispatch({
              type: fromPedido.PEDIDO_FAIL,
              payload: pedidoModel,
            });
            break;
          case 'sucursal':
            dispatch({
              type: fromSucursal.SUCURSAL_FAIL,
              payload: sucursalModel,
            });
            break;
          default:
            break;
        }
      });
  };

export const patchDarBajaArchivoAction =
  (item, co, call) => (dispatch, getState) => {
    let { currentUser } = getState().app;

    switch (call) {
      case 'caja':
        dispatch({
          type: fromCaja.CAJA_PROCESS,
        });
        break;
      case 'chica':
        dispatch({
          type: fromChicaOperacion.CHICAOPERACION_PROCESS,
        });
        break;
      case 'guia':
        dispatch({
          type: fromGuia.GUIA_PROCESS,
        });
        break;
      case 'orden':
        dispatch({
          type: fromOrden.ORDENCOMPRA_PROCESS,
        });
        dispatch({
          type: fromPagos.PAGOS_PROCESS,
        });
        break;
      case 'pedido':
        dispatch({
          type: fromPedido.PEDIDO_PROCESS,
        });
        break;
      case 'sucursal':
        dispatch({
          type: fromSucursal.SUCURSAL_PROCESS,
        });
        break;
      default:
        break;
    }

    dispatch({
      type: ARCHIVO_PROCESS,
    });

    let archivo = {
      ar: item,
      ie: currentUser.ie,
      co: co,
    };

    api
      .patch(`${servicios.ARCHIVO}/baja`, archivo)
      .then(() => {
        mensaje('Operación exitosa');
        dispatch(getArchivosAction({}));
        dispatch(paginado(0));
        dispatch({ type: ARCHIVO_SAVE_SUCCESS });
        switch (call) {
          case 'caja':
            dispatch(fromCaja.getSeleccionarCajaAction());
            dispatch({ type: fromCaja.CAJA_SAVE_SUCCESS });
            break;
          case 'chica':
            dispatch(fromChicaOperacion.getOperacionesCajaChicaAction({}));
            dispatch({ type: fromChicaOperacion.CHICAOPERACION_SAVE_SUCCESS });
            break;
          case 'guia':
            dispatch(fromGuia.getGuiasAction());
            dispatch({ type: fromGuia.GUIA_SAVE_SUCCESS });
            break;
          case 'orden':
            dispatch(fromOrden.getOrdenesCompraAction({}));
            dispatch({ type: fromOrden.ORDENCOMPRA_SAVE_SUCCESS });
            dispatch(fromPagos.getPagosAction());
            dispatch({ type: fromPagos.PAGOS_SAVE_SUCCESS });
            break;
          case 'pedido':
            dispatch(fromPedido.getPedidosAction());
            dispatch({ type: fromPedido.PEDIDO_SAVE_SUCCESS });
            break;
          case 'sucursal':
            dispatch(fromSucursal.getSucursalesAction({}));
            dispatch({ type: fromSucursal.SUCURSAL_SAVE_SUCCESS });
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        dispatch({
          type: ARCHIVO_FAIL,
          payload: error.data.errors ? error.data.errors : archivoModel,
        });
        switch (call) {
          case 'caja':
            dispatch({ type: fromCaja.CAJA_FAIL, payload: cajaModel });
            break;
          case 'chica':
            dispatch({
              type: fromChicaOperacion.CHICAOPERACION_FAIL,
              payload: chicaOperacionModel,
            });
            break;
          case 'guia':
            dispatch({
              type: fromGuia.GUIA_FAIL,
              payload: guiaModel,
            });
            break;
          case 'orden':
            dispatch({
              type: fromOrden.ORDENCOMPRA_FAIL,
              payload: ordenCompraModel,
            });
            break;
          case 'pedido':
            dispatch({
              type: fromPedido.PEDIDO_FAIL,
              payload: pedidoModel,
            });
            break;
          case 'sucursal':
            dispatch({
              type: fromSucursal.SUCURSAL_FAIL,
              payload: sucursalModel,
            });
            break;
          default:
            break;
        }
      });
  };

export const patchAgregarPromocionAction =
  (item, documento) => (dispatch, getState) => {
    let { currentUser } = getState().app;

    dispatch({
      type: ARCHIVO_PROCESS,
    });
    dispatch({
      type: fromSucursal.SUCURSAL_PROCESS,
    });

    let form_data = new FormData();
    form_data.append('file', documento);
    form_data.append('ar', item.ar);
    form_data.append('is', item.is);
    form_data.append('ie', currentUser.ie);
    form_data.append('iu', currentUser.us);

    api
      .patch(`${servicios.SERVICIO}/promocion`, form_data, {
        headers: { 'content-type': 'multipart/form-data; charset=utf-8' },
      })
      .then(() => {
        mensaje('Operación exitosa');
        dispatch(fromSucursal.getSucursalesAction({}));
        dispatch({ type: ARCHIVO_SAVE_SUCCESS });
        dispatch({ type: fromSucursal.SUCURSAL_SAVE_SUCCESS });
      })
      .catch((error) => {
        dispatch({
          type: ARCHIVO_FAIL,
          payload: error.data.errors ? error.data.errors : archivoModel,
        });
        dispatch({
          type: fromSucursal.SUCURSAL_FAIL,
          payload: error.data.errors ? error.data.errors : sucursalModel,
        });
      });
  };

export const getSeleccionarArchivoAction = (item) => (dispatch) => {
  if (item) {
    dispatch({
      type: ARCHIVO_VIEW,
      payload: item,
    });
  } else {
    dispatch({
      type: ARCHIVO_SELECTED,
      payload: archivoModel,
    });
  }
};

export const actualizarFiltros = (filtros) => (dispatch, getState) => {
  let { su, suf, ur, ea, fi, ff } = getState().archivo;

  let item = {
    suf:
      filtros.suf !== undefined
        ? filtros.suf === ''
          ? null
          : filtros.suf
        : suf,
    su: filtros.su !== undefined ? (filtros.su === '' ? null : filtros.su) : su,
    ur: filtros.ur !== undefined ? (filtros.ur === '' ? null : filtros.ur) : ur,
    ea: filtros.ea !== undefined ? (filtros.ea === '' ? null : filtros.ea) : ea,
    fi: filtros.fi !== undefined ? (filtros.fi === '' ? null : filtros.fi) : fi,
    ff: filtros.ff !== undefined ? (filtros.ff === '' ? null : filtros.ff) : ff,
  };

  dispatch({
    type: ARCHIVO_FILTER,
    payload: item,
  });
};

export const paginado = (page) => (dispatch) => {
  dispatch({
    type: ARCHIVO_PAGINATE,
    payload: page,
  });
};

export const closeModal = () => (dispatch) => {
  dispatch({
    type: ARCHIVO_CLOSE,
  });
};
